import React from 'react';
import {Table} from "../table/Table";

class DriverToFreighter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            DriverToFreighterData: this.props && this.props.DriverToFreighterData,
            
        }
       /* console.log(this.props);*/
    }

    
    render() {
        return (
            <>
                <Table
                    tableHeaders={[
                        "شماره هوشمند ناوگان",
                        "پلاک",
                        "سریال",
                        "نام خودرو",
                        "سال ساخت",
                       
                    ]}

                    tableRow={this.state.DriverToFreighterData}

                    tableData={[
                        x => {
                            return x.freighterCardNumber 
                        },
                        x => {
                            return x.plaqueNumber
                        },
                        x => {
                            return x.plaqueSerialNumber 
                        },
                          x => {
                              return x.loadingTypeTitle 
                        },
                          x => {
                              return x.madeYear 
                        },
                         
                    ]}
                />
            </>
        )
    }
}

export default DriverToFreighter;